import { GridColDef } from "@mui/x-data-grid";
import ViewCad from "../../../config/view";
import { initialValuePaciente, Paciente } from "../../paciente/paciente.model";
import { ViewSelecionarPaciente } from "../../paciente/view/paciente.select";
import { AtendimentoViewProps, listPeriodo } from "../atendimento.controller";
import {  handleCancelarTratamentoDispatch, handleRealizarTratamentoDispatch, handleShowCadTratamentoDispatch, } from "../atendimento.router"
import { Atendimento } from "../atendimento.model";
import { addDays } from "date-fns"
import { formatData, getNewId, isEmpty } from "../../../services/utils";
import { Procedimento, Tratamento } from "../../../config/data.types";
import { Alert, AlertTitle, AppBar, Box, Button, Card, CardActions, CardContent, CardHeader, Chip, Grid, IconButton, Stack, TextField, Toolbar, Typography } from "@mui/material";
import { ContentBoxProps, ContentForm } from "../../../components/viewCadastro/formCad";
import { CalendarIcon } from "@mui/x-date-pickers";
import { StripedDataGrid } from "../../../components/select";
import { ViewSelecionarProcedimento } from "../../procedimento/view/procedimento.select";
import { AddBoxOutlined, CalendarTodaySharp, Cancel, Check, CheckBox, EditDocument, EventAvailable, PlusOneRounded, Search } from "@mui/icons-material";
import { JSX, memo, useCallback, useEffect, useState } from "react";
import { handleShowModalSelectPaciente } from "../../paciente/paciente.router"
import ShowDialog from "../../../components/showDialog";


interface AtendimentoCadastroProps extends AtendimentoViewProps {
    handleCloseView: () => any
    procedimento_id?: any
}
export function AtendimentoCadastro(props: AtendimentoCadastroProps) {
    const { atendimentoActions, atendimentoState, handleCloseView, pacienteActions, procedimentoActions, } = props
    const { error, loading, msg, row, showAlert, showDialogExluir, status, showCadModal } = atendimentoState
    const { create, read, update, deletar, set, get, setShowAlert, setShowDialogExluir, novoAtendimento, getAtendimentosByPaciente } = atendimentoActions


    const handleNovo = () => {
        novoAtendimento()
    }

    const handleExcluir = (row: Atendimento) => {
        deletar(row);
        setShowDialogExluir(false);
        handleCloseView();
    }

    const formValidate = (values: Atendimento) => {
        const errors: any = { paciente: {}, tratamento: { procedimento: {} } }
        if (!values.paciente.nome)
            errors.paciente.nome = "Informe o paciente"
        if (!values.tratamento.procedimento)
            errors.tratamento.procedimento.descricao = "Informe o procedimento"
        return errors
    }

    const handleUpdate = (value: Atendimento) => {
        if (!isEmpty(value.tratamento.procedimento)) {
            atendimentoActions.salvarAtendimento(value);
        } else {
            alert("Informe o procedimento!")
        }
    }

    const handleMutator = ([value, field]: any, state: any, { changeValue }: any) => {
        console.log("handelMutator", value, field, state)
        var rowLocal = state.formState.values as Atendimento;
        console.log("rowLocal", rowLocal);
        switch (field) {
            case "paciente":
                changeValue(state, field, () => value)
                break
            case "periodo_retorno":

                let date = addDays(new Date(rowLocal.data), Number(value))
                if (!isEmpty(rowLocal.tratamento.data_tratamento))
                    date = addDays(new Date(rowLocal.tratamento.data_tratamento), Number(value))
                console.log(date)
                changeValue(state, `tratamento.data_retorno`, () => date.toISOString())
                break;
            case "data_tratamento":
                let qtDias = 31;
                if (!isEmpty(rowLocal.tratamento.periodo_retorno))
                    qtDias = Number(rowLocal.tratamento.periodo_retorno);
                let dateRet = addDays(new Date(value), qtDias)
                changeValue(state, `tratamento.data_retorno`, () => dateRet.toISOString())
                break;
            case "data":
                changeValue(state, `tratamento.data_tratamento`, () => value)
                if (!isEmpty(rowLocal.tratamento.periodo_retorno)) {
                    let qtDias = Number(rowLocal.tratamento.periodo_retorno);
                    let dateRet = addDays(new Date(value), qtDias)
                    changeValue(state, `tratamento.data_retorno`, () => dateRet.toISOString())
                }
                break;
            default:
                break;
        }

    }

    const TratamentosListView = (props: ContentBoxProps<Atendimento>): JSX.Element | null => {
        console.log("Atualizou tela TratamentosListView", props)
        const [showMensage, setShowMensage] = useState(false)
        const { form, values } = props;
        if (!form || !values) {
            // Render nothing or a fallback if required props are missing
            return null;
        }


        const addTratamento = (procedimento: Procedimento) => {
            let newTratamento: Tratamento = {
                ...values.tratamento,
                procedimento: procedimento,
            }
            form.change("tratamento", newTratamento)
        }

        if (values.tratamento)
            return (
                <Box sx={{ flex: 1, mt: 2 }}>
                    <Card>
                        <CardHeader
                            title={values.tratamento.procedimento.descricao}
                            disableTypography
                            sx={{ mb: 1 }}
                            action={
                                <IconButton title="Alterar procedimento" onClick={() => procedimentoActions.selecionarProcedimento(true)}>
                                    <Search />
                                </IconButton>
                            }

                        />
                        <CardContent >
                            <Grid container spacing={1} flexDirection={"row"} >
                                <ContentForm
                                    fieldName={`tratamento.periodo_retorno`}
                                    label="Período Retorno"
                                    type="select"
                                    colunsXS={12} colunsSM={6} colunsMD={4}
                                    radioOptionsValues={listPeriodo.map(value => {
                                        return { label: value.periodo, value: value.qtdias }
                                    })}
                                    handleChangeMutator={(f, value, vf) => { form.mutators.handleMutator(value, "periodo_retorno") }}
                                    tip="Periodo de retorno do paciente baseado na data em que o procedimento foi realizado ou data de inicio caso ainda nao tenha realizado"
                                />
                                <ContentForm
                                    fieldName={`tratamento.data_tratamento`}
                                    label="Data Realizado"
                                    type="data"
                                    colunsXS={12} colunsSM={6} colunsMD={4}
                                    handleChangeMutator={(f, value, m) => form.mutators.handleMutator(value, "data_tratamento")}
                                    tip="Data em foi realizado o procedimento"
                                />

                                <ContentForm
                                    fieldName={`tratamento.data_retorno`}
                                    label="Data Retorno"
                                    type="data"
                                    colunsXS={12} colunsSM={6} colunsMD={4}
                                    tip="Data em que o paciente irá retornar baseado no período selecionado"
                                />
                            </Grid>
                        </CardContent>
                        <CardActions sx={{ mt: 1, justifyContent: "end" }}>
                            <Button
                                startIcon={<EventAvailable />}
                                title="Marcar data do tratamento realizado hoje"
                                onClick={() => setShowMensage(true)}
                                variant="contained"
                                color="success"
                                disabled={(isEmpty(values.tratamento.procedimento) || isEmpty(values._id))}
                            >
                                Tratamento Realizado
                            </Button>
                            <ShowDialog
                                title="Tratamento Realizado Hoje"
                                msg="Confirma a realização do tratamento na data de hoje?"
                                close={() => setShowMensage(false)}
                                ok={() => atendimentoActions.handleRealizarTratamento()}
                                open={showMensage}

                            />
                        </CardActions>

                    </Card>
                    <Card>
                        <ContentForm
                            fieldName={`obs`}
                            label="Observações"
                            type="text"
                            multline
                            multlineMaxRow={3}
                            colunsXS={12} colunsSM={12} colunsMD={12}
                            tip="Observações sobre o tratamento do paciente"
                        />
                    </Card>
                    {/*                     {rowsAtendimentosByPaciente.length > 0 && (
                        <Alert variant="filled" severity="warning">
                            <AlertTitle>Atendimentos com esse paciente</AlertTitle>
                            {rowsAtendimentosByPaciente.map(atends=>(
                                <Chip key={atends._id} label={atends.tratamento.procedimento.descricao} />
                            ))}
                        </Alert>
                    )} */}

                    <ViewSelecionarProcedimento
                        handleConfirmar={(procedimento) => {
                            if (procedimento._id)
                                addTratamento(procedimento);
                            procedimentoActions.setShowSelectModal(false);
                        }}
                    />
                </Box>
            );
        return <></>
    }

    var viewCad = new ViewCad({
        formTitle: row._id ? "Atendimento de : " + row.paciente.nome : "Cadastro de Atendimento",
        formFieldDescription: "nome",
        loading: loading,
        msg: msg,
        row: row,
        status: status,
        showAlert: showAlert,
        showDialogExluir: showDialogExluir,
        buttonNovo: {
            show: !isEmpty(row._id),
            title: "Adicionar novo tratamento",
            onClick: () => handleNovo(),
        },
        handleExcluir: handleExcluir,
        formValidate: formValidate,
        handleUpdate: handleUpdate,
        handleCloseAlert: () => setShowAlert(false),
        setShowDialogExluir: setShowDialogExluir,
        handleCloseView: () => handleCloseView(),
        handleMutator: handleMutator,
        contentForm: [
            { fieldName: "data", label: "Inicio Tratamento", type: "data", key: "data", colunsXS: 12, colunsSM: 4, colunsMD: 4, tip: "Data que iniciou o tratamento", handleChangeMutator: (func, value) => func(value, "data") },
            {
                fieldName: "paciente.nome", label: "Paciente", type: "select-dialog", key: "paciente",
                colunsXS: 12, colunsSM: 8, colunsMD: 8, require: true,
                ViewSelecionarDialog: (propsDialog) => {
                    return (
                        <ViewSelecionarPaciente handleConfirmar={(paciente: Paciente) => {
                            console.log("paciente selecionado", paciente, propsDialog);
                            if (paciente._id) {
                                propsDialog.handleMutator(paciente, "paciente");
                            }
                            pacienteActions.setShowSelectModal(false)
                        }} />
                    )
                },
                handleOnClickShow: () => handleShowModalSelectPaciente()
            },
            { fieldName: "situacao", label: "Situacão do Atendimento", type: "radio", key: "situacao", colunsXS: 12, colunsSM: 4, colunsMD: 4, radioOptionsValues: [{ label: "Ativo", value: "ativo" }, { label: "Inativo", value: "inativo" }], require: true },
            { fieldName: "tratamento", label: "tratamento", type: "text", key: "obs", colunsXS: 12, colunsSM: 12, colunsMD: 12, hidden: () => true },

        ],
        ContentBox: (props) => <TratamentosListView {...props as ContentBoxProps<Atendimento>} />
    })

    return viewCad
}



